import { render } from "./flightInfo.vue?vue&type=template&id=4b087490&scoped=true"
import script from "./flightInfo.vue?vue&type=script&lang=js"
export * from "./flightInfo.vue?vue&type=script&lang=js"

import "./flightInfo.vue?vue&type=style&index=0&id=4b087490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b087490"]])

export default __exports__